import { useState } from 'react';
import { useConnect } from 'wagmi';
import Card from './Card';
import {
  GetLastConnectedWallet,
  SetLastConnectedWallet,
  WalletsName,
  WalletsType,
} from '../../ConnectedWallet/wallets.ls';
import { useWallet } from '../../../wallet/walletContext';
import useMobileDetect from '../../../pages/MainPage/useMobileDetect';
import { ISubModalState } from '.';

import MetamaskIcon from './images/metamask.svg';
import WalletConnect from './images/wallet_connect.svg';
// import Unstoppable from './images/unsoppable/default-small.svg';
import Ledger from './images/ledger-square.svg';
import Coinbase from './images/coinbase.svg';
import TronLink from './images/tronLink.png';
import MultiversX from './images/multiversX.png';
import Brave from './images/brave.svg';
import Ton from './images/ton.webp';
import Trezor from './images/trezor.png';
import BlockWallet from './images/blockwallet.svg';

const onMetamaskDownload = () => {
  window.open('https://metamask.io/download/', '_blank');
};

interface IConnectorWalletsProps {
  onCancel: () => void;
  setSubModal: (value: ISubModalState) => void;
}

const ConnectorWallets = ({
  onCancel,
  setSubModal,
}: IConnectorWalletsProps) => {
  const [lock, setLock] = useState(false);
  const { isMobile } = useMobileDetect();
  const { connectors } = useConnect();
  const { onConnect } = useWallet();

  const lastWallet = GetLastConnectedWallet();
  const sortedConnectors = [...connectors].sort((x) =>
    x.id === lastWallet ? -1 : 1
  );

  return (
    <div className='connect_modal__contents'>
      <p className='connect_modal__contents__disclaimer'>
        Use walletconnect for log in or your browser in the mobile wallet
      </p>
      {sortedConnectors.map((connector) => {
        if (!connector.ready) {
          if (connector.id === WalletsType.MetaMask) {
            return (
              <Card
                key={connector.id}
                lock={lock}
                title='Install MetaMask'
                icon={MetamaskIcon}
                onClick={onMetamaskDownload}
              />
            );
          }
          return;
        }

        if (connector.id === WalletsType.Other) {
          if (connector.name === WalletsName.Brave) {
            return (
              <Card
                key={connector.id}
                lock={lock}
                title='Brave Wallet'
                icon={Brave}
                onClick={() => {
                  SetLastConnectedWallet(WalletsType.Other);
                  onConnect(connector, onCancel);
                }}
              />
            );
          }
          if (connector.name === WalletsName.BlockWallet) {
            return (
              <Card
                key={connector.id}
                lock={lock}
                title='BlockWallet'
                icon={BlockWallet}
                onClick={() => {
                  SetLastConnectedWallet(WalletsType.Other);
                  onConnect(connector, onCancel);
                }}
              />
            );
          }
          return;
        }

        switch (connector.name) {
        case WalletsName.WalletConnect:
          return (
            <Card
              key={connector.id}
              lock={lock}
              title='WalletConnect'
              icon={WalletConnect}
              onClick={() => {
                SetLastConnectedWallet(WalletsType.WalletConnect);
                onConnect(connector, onCancel);
              }}
            />
          );
        case WalletsName.MetaMask:
          return (
            <Card
              key={connector.id}
              lock={lock}
              title='Connect browser wallet'
              icon={MetamaskIcon}
              onClick={() => {
                SetLastConnectedWallet(WalletsType.MetaMask);
                onConnect(connector, onCancel);
              }}
            />
          );
        case WalletsName.Ledger:
          return (
            <Card
              key={connector.id}
              lock={lock}
              title='Connect with Ledger'
              icon={Ledger}
              additionalClass='ledger-icon'
              onClick={() => {
                SetLastConnectedWallet(WalletsType.Ledger);
                onConnect(connector, onCancel);
              }}
            />
          );
        case WalletsName.Coinbase:
          return (
            <Card
              key={connector.id}
              lock={lock}
              title='Coinbase Wallet'
              icon={Coinbase}
              onClick={() => {
                SetLastConnectedWallet(WalletsType.Coinbase);
                onConnect(connector, onCancel);
              }}
            />
          );
        case WalletsName.MultiversX:
          return (
            <Card
              key={connector.id}
              lock={lock}
              title='MultiversX'
              icon={MultiversX}
              onClick={() => {
                if (isMobile) {
                  window.location.href = 'https://xportal.com/';
                } else {
                  SetLastConnectedWallet(WalletsType.MultiversX);
                  onConnect(connector, onCancel);
                }
              }}
            />
          );
        case WalletsName.TronLink:
          return (
            <Card
              key={connector.id}
              lock={lock}
              title='TronLink'
              icon={TronLink}
              onClick={() => {
                if (isMobile) {
                  window.location.href = 'https://www.tronlink.org/';
                } else {
                  SetLastConnectedWallet(WalletsType.TronLink);
                  onConnect(connector, onCancel);
                }
              }}
              additionalClass='tronLink-icon'
            />
          );
        case WalletsName.TON:
          return (
            <Card
              key={connector.id}
              lock={lock}
              title='TON Wallet'
              icon={Ton}
              onClick={async () => {
                const subWallets = await connector.options.getSubWallets();
                setSubModal({ wallets: subWallets, connector });
              }}
            />
          );
        case WalletsName.TREZOR:
          return (
            <Card
              key={connector.id}
              lock={lock}
              title='Trezor Suite'
              icon={Trezor}
              additionalClass='rounded-icon'
              onClick={() => {
                SetLastConnectedWallet(WalletsType.TREZOR);
                onConnect(connector, onCancel);
              }}
            />
          );
          // case WalletsName.UnstoppableDomains: {
          //   return (
          //     <Card
          //       key={connector.id}
          //       lock={lock}
          //       title='UnstoppableDomains'
          //       icon={Unstoppable}
          //       onClick={() => {
          //         SetLastConnectedWallet(WalletsType.UnstoppableDomains);
          //         onConnect(connector, notify, onCancel);
          //       }}
          //     />
          //   );
          // }
        }
      })}
      {/* <Card lock={lock} title="Maiar wallet" icon={Unstoppable} onClick={onConnectMaiarWallet} /> */}
    </div>
  );
};

export default ConnectorWallets;
